<template>
  <div>
    <MainNavBar />
    <Hero :hero="heroBuildingKnowledgeAccelerator" />
    <SectionTrinpodServer />
    <SectionTrinappSuite />
    <CallToAction :content="buildingCTA" />
    <GmxFooter />
  </div>
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import MainNavBar from '@/components/main-nav-bar.vue';
import Hero from '@/components/hero.vue';
import Section from '@/components/section.vue';
import SectionTrinpodServer from '@/components/section-trinpod-server.vue';
import SectionTrinappSuite from '@/components/section-trinapp-suite.vue';
import CallToAction from '@/components/call-to-action.vue';
import GmxFooter from '@/components/footer.vue';
export default {
  name: 'BuildingKnowledgeAccelerator',
  components: {
    MainNavBar,
    Hero,
    Section,
    SectionTrinpodServer,
    SectionTrinappSuite,
    CallToAction,
    GmxFooter
  },
  data() {
    return { 
      heroBuildingKnowledgeAccelerator: { 
        eyebrowIcon: 'trinity_construction.png',
        eyebrowTitle: 'TrinPod\u2122 Server + TrinApp\u2122 Suite',
        eyebrowSubtitle: '',
        header: 'Building Knowledge Accelerator',
        subheader: 'Save time, own and control your data, collaborate globally, produce more, and find previously unfindable information on any device.',
        img: 'hero-intelligentPDF.png',
        videoId: '699342008',
        buttons: [
          { label: 'TrinPod\u2122 Server', path: '', id: 'trinpod-server' },
          { label: 'TrinApp\u2122 Suite', path: '', id: 'trinapp-suite' },
        ]
      },
      /*saveTime: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Save time',
        paragraphs: [
          'by quickly finding actionable information'
        ],
        id: 'save-time',
        image: 'placeholder.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-light-grad',
      },
      /*ownControlData: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Own and Control Your Data',
        paragraphs: [
          'in the cloud or on premise with your own domain'
        ],
        id: 'own-and-control-your-data',
        image: 'placeholder.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-neon-blue-grad',
      },
      collaborateGlobally: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Collaborate Globally',
        paragraphs: [
          'with advanced security using Solid\'s globally interoperable API and W3C standard Linked Data'
        ],
        id: 'collaborate-globally',
        image: 'placeholder.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-light-grad',
      },
      produceMore: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Produce more',
        paragraphs: [
          'by modeling, automating and controlling systems with a growing Solid app ecosystem and building custom applications'
        ],
        id: 'produce-more',
        image: 'placeholder.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-neon-blue-grad',
      },
      findUnfindable: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Find Previously Unfindable Information',
        paragraphs: [
          'by linking all documents and systems together in TrinPodTM using Crosslink '
        ],
        id: 'find-unfindable',
        image: 'placeholder.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-light-grad',
      },*/
      buildingCTA: {
        header: 'Start using TrinPod\u2122',
        bgClass: 'bg-neon-blue-grad',
        btnText: "Get started - it's free",
        btnVariant: 'turquoise'
      }
    }
  }
};
</script>
